<template>
  <div class="calendar-hours-list">
    <div
      v-for="item in handleHoursPoints"
      :key="item.label"
      class="calendar-hours-item"
    >
      <span
        class="calendar-hours-label"
        :class="{
          'hide': isToday && !item.visiable
        }"
      >{{ item.label }}</span>
      <div class="calendar-hours-line"></div>
    </div>
    <slot />
  </div>
</template>
<script>
import calendarUtils from '@/utils/calendar'
export default {
  name: 'CalendarHoursList',
  props: {
    isToday: {
      type: Boolean,
      default: false
    }
  },
  data () {
    return {
      hoursPoints: calendarUtils.getHoursList()
    }
  },
  computed: {
    handleHoursPoints () {
      const [res, ...hoursPoints] = this.hoursPoints
      res.label = ''
      return [res, ...hoursPoints]
    }
  },
  mounted () {
    this.setHourLabel()
    this.updateByTime()
  },
  methods: {
    updateByTime () {
      clearTimeout(this.timer)
      this.setHourLabel()
      this.timer = setTimeout(() => {
        this.updateByTime()
      }, 1000 * 30)
    },
    setHourLabel () {
      this.hoursPoints.forEach((item) => {
        item.visiable = Math.abs(moment(item.label, 'HH:mm').diff(moment(), 'minute')) > 9
      })
    }
  },
  beforeDestroy () {
    this.timer && clearTimeout(this.timer)
  }
}
</script>
<style lang="stylus">
.calendar-hours
  &-list
    position relative
  &-item
    display flex
    height 60px
  &-label
    width 50px
    font-size 10px
    color #999
    &.hide
      opacity 0
  &-line
    flex 1
    margin-top 10px
    border-top 1px solid #F1F2F3
</style>
